/* VH Life — friend referral attribution.
 *
 * A referral link carries ?friend=<code>. This stores that code and writes it onto
 * the cart as an attribute, so it lands on the order in Shopify admin and the £10
 * credit can be paid to the right person.
 *
 * The parameter is `friend`, NOT `ref`: GoAffPro's loader already claims `ref` for
 * creator-affiliate attribution, and a customer referral must not be recorded as an
 * affiliate sale at 30%.
 */
(function () {
  var PARAM = 'friend';
  var KEY = 'vh_friend_ref';
  var ATTR = 'Referred by friend';
  var DAYS = 30;

  /* Codes end up in a cart attribute that staff read, so keep them to a safe,
     predictable shape rather than trusting whatever is in the URL. */
  function clean(v) {
    if (!v) return '';
    return String(v).trim().toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 32);
  }

  function store(code) {
    try { localStorage.setItem(KEY, code); } catch (e) {}
    var d = new Date();
    d.setTime(d.getTime() + DAYS * 864e5);
    document.cookie = KEY + '=' + code + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function read() {
    try {
      var v = localStorage.getItem(KEY);
      if (v) return v;
    } catch (e) {}
    var m = document.cookie.match(new RegExp('(?:^|; )' + KEY + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  var fromUrl = '';
  try {
    fromUrl = clean(new URLSearchParams(window.location.search).get(PARAM));
  } catch (e) {}

  if (fromUrl) store(fromUrl);

  var code = fromUrl || read();
  if (!code) return;

  /* Write it to the cart. Shopify keeps cart attributes through checkout and shows
     them on the order, which is what makes this readable without an app.
     Fire and forget: a failure here must never block the page or the add-to-cart. */
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: (function () { var a = {}; a[ATTR] = code; return a; })() })
  }).catch(function () {});
})();
